<template>
  <div v-if="dataAgent">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết Merchant</h1>
      <div class="btn-group float-right">
        <router-link to="/agent" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-arrow-back"></i> Quay lại
        </router-link>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="media mb-3">
          <img src="@/assets/img/user.svg" class="mr-3" alt="img" />
          <div class="media-body">
            <h5 class="mt-0">{{ dataAgent.name }}</h5>
            <span v-if="dataAgent.stateAgent === 'ACTIVING'" class="badge badge-success"
              >Đang hoạt động</span
            >
            <span v-if="dataAgent.stateAgent === 'WAITING_APPROVED'" class="badge badge-primary"
              >Đang xử lý</span
            >
            <span v-if="dataAgent.stateAgent === 'LOCKED'" class="badge badge-danger">Đã khóa</span>
          </div>
        </div>
        <div class="col-12">
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-detail">
                <h1>Thông tin MC</h1>
                <div class="form-group form-row">
                  <label class="col-sm-4 col-form-label"
                    >Tên Merchant <span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ dataAgent.name }}</p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-sm-4 col-form-label"
                    >MST/ ĐKKD<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12"></p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-sm-4 col-form-label"
                    >Ngành hàng<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12"></p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label class="col-sm-4 col-form-label"
                    >Địa chỉ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ dataAgent.address }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { mapGetters } from 'vuex'

  export default {
    name: 'agentDetail',
    data() {
      return {
        dataAgent: null,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.loading = true
          const data = await AgentService.getOneAgent({ agentId: this.$route.params.id })
          if (data.success) {
            this.dataAgent = data.data
            return
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
        await this.$router.push('/agent')
      },
    },
  }
</script>
